import { Component, OnInit, Input, EventEmitter, Output, HostListener} from '@angular/core';

@Component({
  selector: 'app-header-desktop-implement',
  templateUrl: './header-desktop-implement.component.html',
  styleUrls: ['./header-desktop-implement.component.scss']
})
export class HeaderDesktopImplementComponent implements OnInit {
   private mood: number = 1;
   private size: number = parseInt(getComputedStyle(document.documentElement).fontSize);
   private el: HTMLElement;
   // Objeto representativo del menú
   @Input() menuOptions: string;
   @Input() isHome: string;
   @Input() isbeta: string ;
   @Input() withNotification: string;

   @Output() translate = new EventEmitter<string>();
   @Output() todoCompleted= new EventEmitter<string>();

   translateHandler() {
     this.translate.emit();
   }

  todoCompletedHandler(ev) {
    this.todoCompleted.emit(ev);
  }

  componentDidRender(){
    this.setMenu();
  }
  private setMenu() {
    const options: any[] = JSON.parse(this.menuOptions);
    const menuOptions = this.el.querySelectorAll(".nav-items-desktop");
    let menuHtml: string = '';

    options.forEach((element) => {
      menuHtml += '<li class="nav-item '+
                  (element.state == 'active'? 'active': '') + '">'+
                  '   <a href="'+element.url+'" class="nav-link">' +
                        element.name +
                  '    </a>'+
                  '</li>';
      if(element.withNotification =='true' && element.state == 'active')
      {
        this.showNotification();
      }
    });
    menuOptions.forEach(element => {
      element.innerHTML = menuHtml;
    });

  }
  private showNotification(){
    const notification = this.el.querySelectorAll("#notificationHeader");
    let notificationHtml =`<div class="container px-0">
        <div class="alert alert-warning">
          <div class="container-notifications-header">
            <a href="/biblioteca/" class="w-100">
              Si eres una entidad y necesitas información para realizar la integración de tu sede electrónica o portal ingresa <strong>AQUÍ</strong>
            </a>
          </div>
        </div>
      </div>`;
      notification.forEach(element => {
        element.innerHTML = notificationHtml;
      })
  }
  componentDidLoad(){
    let searchTerm = this.el.querySelectorAll('.searchTerm');
    searchTerm.forEach(searchItem => {
       searchItem.addEventListener("focusin", this.searchFocus);
       searchItem.addEventListener("focusout", this.searchOutFocus);
       searchItem.addEventListener("keyup", this.searchGovCo);
    });
    this.initValue();
  }

  constructor() { }

  ngOnInit() {
  }

  // Header Nvl 1: Función para ocultar la sección de notificación
  hiddenNotification = () =>  {
    const notification: any = this.el.querySelector('.navbar-notifications');
    notification.style.display = 'none';
  }
  // Header Nvl 2: Función para activar la animación de búsqueda
  searchFocus = (e) =>  {
    const id = e.currentTarget.id;
    const searchBar = this.el.querySelector('.' + id + '-container');
    searchBar.classList.add('form-search-bar-active');
  }
  // Header Nvl 2: Función para ocultar la animación de búsqueda
  searchOutFocus = (e) =>  {
    const id = e.currentTarget.id;
    const searchBar = this.el.querySelector('.' + id + '-container');
    searchBar.classList.remove('form-search-bar-active');
  }
  // Header Nvl 2: Función para redireccionar búsqueda a gov.co
  searchGovCo = (e) =>  {
    var code = e.key;
    if(code === "Enter") {
      const id = e.currentTarget.id;
      let searchTerm  = this.el.querySelector('.' + id + "-searchTerm") as HTMLInputElement;
      document.location.href = encodeURI(location.origin+"/buscador/" + searchTerm.value);
    }
  }

  // Header Nvl 2: Función para implementar la funcionalidad de translate
  // TODO: Funcionalidad translate
  changeLang() {
    const langGovco = this.el.querySelector('.lang-govco');
    if (langGovco.classList.contains('govco-icon-language-es-n')) {
      this.todoCompletedHandler('es-es');
    }else if (langGovco.classList.contains('govco-icon-language-en-n')) {
      this.todoCompletedHandler('en-en');
    }
  }
  btnSearchGovCo(){
    let searchTerm  = this.el.querySelector("#search-desktop") as HTMLInputElement;
    document.location.href = location.origin+'/buscador/'  + searchTerm.value;
  }

  // Función evento que captura el evento scroll sobre el elemento window
  // @HostListener('scroll', { target: 'window' })
  // handleScroll() {
  //   this.hiddenMenu();
  // }

   // Función que realiza el evento de ocultar el segundo menu y visualizar
  // opciones en el primer menu
  hiddenMenu() {
    const scrollOffset = document.body.scrollTop || document.documentElement.scrollTop;
    const firstMenu = this.el.querySelector('.nav-primary');
    const secondMenu = this.el.querySelector('.nav-secondary');
    const itemFirstMenu = this.el.querySelector('.nav-item-primary');
    const searchNavbar = this.el.querySelector('.search-navbar');
    const formSearchBar = this.el.querySelector('.form-search-bar');

    // Valida la posición del scroll para activar/inactivar animación
    if (scrollOffset < 300) { this.initValue(); } else {
      if(firstMenu != null) firstMenu.classList.remove('hidden-transition');
      if(secondMenu != null) secondMenu.classList.remove('show-transition');
      if (firstMenu != null && firstMenu.classList.contains('show-transition') === false) {
        firstMenu.classList.add('show-transition');
        itemFirstMenu.classList.remove('is-scroll');
      }
      if (secondMenu!= null && secondMenu.classList.contains('hidden-transition') === false) {
        secondMenu.classList.add('hidden-transition');
      }
      if (searchNavbar != null && searchNavbar.classList.contains('translation') === false) {
        searchNavbar.classList.add('translation');
        searchNavbar.classList.remove('non-translation');
      }
      if (formSearchBar != undefined && formSearchBar.classList.contains('none-visibility') === false) {
        formSearchBar.classList.add('none-visibility');
      }
    }
  }

  // Función para asignar valores iniciales a la animación de segundo menú
  private initValue() {
    const firstMenu = this.el.querySelector('.nav-primary');
    const secondMenu = this.el.querySelector('.nav-secondary');
    const itemFirstMenu = this.el.querySelector('.nav-item-primary');
    const searchNavbar = this.el.querySelector('.search-navbar');
    const formSearchBar = this.el.querySelector('.form-search-bar');
    const iconSearch = this.el.querySelector('.icon-search') as any;

    if (firstMenu.classList.contains('hidden-transition') === false) {
      itemFirstMenu.classList.add('is-scroll');
      firstMenu.classList.add('hidden-transition');
      firstMenu.classList.remove('show-transition');
    }
    if (secondMenu.classList.contains('show-transition') === false) {
      secondMenu.classList.remove('hidden-transition');
      secondMenu.classList.add('show-transition');
    }
    if (searchNavbar.classList.contains('translation')) {
      searchNavbar.classList.remove('translation');
      searchNavbar.classList.add('none-translation');
    }
    if (formSearchBar != undefined) {
      formSearchBar.classList.remove('none-visibility');
        iconSearch.style.display = "block";
    }
  }
}
